import {Button, Card, Flex, Input, Popover, Space, Tooltip} from "antd";
import React, {useEffect} from "react";
import TextArea from "antd/es/input/TextArea";
import {useDebounce} from "use-debounce";
import {generateSettingPrompt} from "./prompts/SettingPrompts";
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../../../../feature/tools";
import {DraftComponents} from "../../../../../../feature/Draft";
import {updateSetting} from "../../../../../../feature/project/draftSlice";
import {aiChainPrompt} from "../../../../../../ai/Prompt";
import {DebounceInput} from "../../../../../../components/DebounceInput";
import {GenButton} from "../../../../../../ai/components/GenButton";
import {TextAreaActions} from "../../../../../../ai/components/TextAreaActions";

export const SettingDetails = (
    props: { data: DraftComponents }
) => {
    const draft = useAppSelector(state => state.draftSlice.draft)
    const model = useAppSelector(state => state.draftSlice.model)
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [prompt, setPrompt] = React.useState('')
    const [title, setTitle] = React.useState(props.data.title)
    const [description, setDescription] = React.useState(props.data.description)
    const [debouncedTitle] = useDebounce(title, 500);
    const [debouncedDescription] = useDebounce(description, 500);

    useEffect(() => {
        dispatch(updateSetting({
            // @ts-ignore
            setting: {
                ...props.data,
                description: debouncedDescription
            }
        }))
    }, [debouncedDescription]);

    useEffect(() => {
        dispatch(updateSetting({
            // @ts-ignore
            setting: {
                ...props.data,
                title: debouncedTitle
            }
        }))
    }, [debouncedTitle]);

    const generateSetting = async () => {
        let data = await aiChainPrompt({
            projectId: projectId ?? "",
            prompt: generateSettingPrompt({
                genres: draft.properties.genre,
                synopsis: draft.properties.synopsis,
                customPrompt: prompt
            }),
            model: model,
            type: 'json'
        })
        dispatch(
            updateSetting(
                {
                    // @ts-ignore
                    setting: {
                        ...props.data,
                        title: data.data.title,
                        description: data.data.description
                    }
                }
            )
        )
    }

    useEffect(() => {
        setTitle(props.data.title ?? '')
        setDescription(props.data.description ?? '')
    }, [props.data]);

    return (
        <>
            <Flex vertical={true} gap={10}
                  style={{
                      height: "100%",
                      overflow: 'hidden'
                  }}>
                <Card styles={{body: {height: 'calc(100% - 72px)'}}} style={{flexGrow: 1, height: '100%'}}
                      title={<Flex justify={'space-between'}>
                          <Flex gap={10} style={{flexGrow: 1}}>
                              <DebounceInput
                                  style={{fontWeight: 'bold'}}
                                  placeholder={"Setting name (e.g. Futuristic Cyberpank)"}
                                  value={title}
                                  onChange={(text) => {
                                      setTitle(text)
                                  }}/>

                              <Space>
                                  <Popover
                                      placement={'bottomRight'}
                                      content={
                                          <Space direction={'vertical'}>
                                              <TextArea onChange={(e) => setPrompt(e.target.value)}
                                                        value={prompt}
                                                        autoSize={true}
                                                        style={{width: 300}}
                                                        placeholder={"e.g. Futuristic Cyberpank"}
                                              />
                                              <Space><Button
                                                  type={'primary'}
                                                  onClick={async () => {
                                                      setLoading(true)
                                                      setOpen(false)
                                                      await generateSetting()
                                                      setLoading(false)
                                                  }}>Go</Button>
                                              </Space>
                                          </Space>
                                      }
                                      title="Short description (optional)"
                                      trigger="click"
                                      open={open}
                                      onOpenChange={(e) => setOpen(e)}
                                  >
                                      <GenButton
                                          loading={loading}
                                          type={'primary'}
                                          actions={[{
                                              key: "1",
                                              title: "Generate",
                                              action: async (model: string) => {
                                                  setOpen(true)
                                              }
                                          }
                                          ]}/>
                                  </Popover>

                              </Space>
                          </Flex>
                      </Flex>}>

                    <TextAreaActions
                        style={{border: "none", minHeight: 200, maxHeight: '100%'}}
                        autoSize={true}
                        value={description}
                        validate={text => true}
                        onChange={(text: string) => {
                            setDescription(text)
                        }}
                    />
                </Card>
            </Flex>
        </>
    )
}